module.exports = __webpack_public_path__ + "img/AT0000002595864.51289149.png";